import * as React from 'react';

import {Stack} from '../../../layout/stack/stack';
import {FormattedTimestamp} from '../../../timestamp/formatted-timestamp';
import {Body} from '../../../typography/body';

import styles from './submission-card.module.css';

type Props = {
    submission: any;
    messageContent: React.ReactNode;
};

export function SubmissionCard(props: Props) {
    const {submission, messageContent} = props;
    const values =
        (submission &&
            submission.fields &&
            // @ts-expect-error
            submission.fields.edges.map((field) => field.fieldValue)) ||
        [];
    const labels =
        (submission &&
            submission.fields &&
            // @ts-expect-error
            submission.fields.edges.map((field) => field.node.label)) ||
        [];
    const additionalAttendees =
        (submission &&
            submission.booking &&
            submission.booking.additionalAttendees.map(
                // @ts-expect-error
                (attendee) =>
                    attendee &&
                    attendee.emailAddresses &&
                    attendee.emailAddresses.primary &&
                    attendee.emailAddresses.primary.value &&
                    attendee.emailAddresses.primary.value.address
            )) ||
        [];

    // @ts-expect-error
    const formattedValues = values.map((value) => {
        switch (value && value.__typename) {
            case 'FormFieldSubmissionValueSingle':
                return value.value;
            case 'FormFieldSubmissionValueMultiple':
                return value.values.join(', ');
            case 'FormFieldSubmissionValueSubfields':
                // @ts-expect-error
                return value.subfieldValues.map((s) => s && s.value).join(', ');
            default:
                return String(value);
        }
    });

    const bookingTime = submission && submission.booking && submission.booking.startTime;

    return (
        <Stack spacing={8} isFullWidth={true}>
            <Body color='dark' isBold={true}>
                {messageContent}
            </Body>
            <div className={styles['submission-card']}>
                {bookingTime && (
                    <Stack spacing={4} isHorizontal={true} isFullWidth={true} alignItems='center'>
                        <Body isBold={true} size='small'>
                            When:
                        </Body>
                        <FormattedTimestamp
                            format={FormattedTimestamp.formats.longDayMonthWithAtTime}
                            datetime={bookingTime}
                        />
                    </Stack>
                )}
                {additionalAttendees && additionalAttendees.length > 0 && (
                    <Stack spacing={4} isHorizontal={true} isFullWidth={true} alignItems='center'>
                        <Body isBold={true} size='small'>
                            Guests:
                        </Body>
                        <Body color='dark' size='small'>
                            {additionalAttendees.join(', ')}
                        </Body>
                    </Stack>
                )}
                {formattedValues && formattedValues.length > 0 && (
                    <Stack spacing={8} isFullWidth={true}>
                        {/* @ts-expect-error */}
                        {formattedValues.map((val, index) => (
                            <div
                                key={`${val}-${Math.random()}`}
                                className={styles['submission-card-item']}
                            >
                                <Body size='small'>
                                    {labels[index]}: {val}
                                </Body>
                            </div>
                        ))}
                    </Stack>
                )}
            </div>
        </Stack>
    );
}
